import StudentRegisterModal from "@/components/modals/StudentRegisterModal"
import ScreenWrapper from "@/components/ScreenWrapper"
import { LessonIntakeDialog } from "@/pages/agenda/LessonIntakeDialog"
import { createFileRoute } from "@tanstack/react-router"
import {
  getAllSchedule,
  getSchedule,
  scheduleQueryKeys,
  useCurrentStudentSuspenseQuery,
  EventModalProvider,
  useEventModalContext,
} from "students-api"
import { ScheduleCalendar } from "toptaal-shared"

export const Route = createFileRoute("/agenda/")({
  component: RouteComponent,
})

function AgendaContent() {
  const { data: currentUser } = useCurrentStudentSuspenseQuery()

  const {
    selectedEvent,
    openEventModal: handleEventClick,
    isRegisterModalOpen,
    handleRegisterModalOpen,
    handleRegisterModalClose,
  } = useEventModalContext()

  const toggleRegisterModal = () => {
    if (isRegisterModalOpen) {
      handleRegisterModalClose()
    } else {
      handleRegisterModalOpen()
    }
  }

  return (
    <ScreenWrapper className="pt-8">
      <ScheduleCalendar
        id={currentUser.userId}
        onEventClick={handleEventClick}
        getQueryKey={scheduleQueryKeys.student}
        queryFn={({ id, startDate, endDate }) =>
          getSchedule({ studentId: id, startDate, endDate })
        }
        getAllScheduleQueryKey={() => scheduleQueryKeys.studentAllSchedule()}
        getAllScheduleQueryFn={() => getAllSchedule()}
      />
      <LessonIntakeDialog />
      <StudentRegisterModal
        isRegisterModalOpen={isRegisterModalOpen}
        setIsRegisterModalOpen={toggleRegisterModal}
        entityType={selectedEvent?.type}
      />
    </ScreenWrapper>
  )
}

function RouteComponent() {
  return (
    <EventModalProvider>
      <AgendaContent />
    </EventModalProvider>
  )
}
